import { render, staticRenderFns } from "./ServizioPeriodicoNote.vue?vue&type=template&id=483903a2&"
import script from "./ServizioPeriodicoNote.vue?vue&type=script&lang=ts&"
export * from "./ServizioPeriodicoNote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports